<template>
  <div class="checkbox-container">
    <input
      :id="id || label"
      type="checkbox"
    >
    <label
      :for="id || label"
      :data-testid="id || label"
      @click="onClick"
    >
      <span class="checkbox-check" />
      <span class="checkbox-box" />
      <div class="checkbox-label">{{ label }}</div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'LegacyCheckbox',
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isClicked: false,
    };
  },
  methods: {
    onClick() {
      this.isClicked = !this.isClicked;
      this.$emit('on-click', this.isClicked);
    },
  },
};
</script>

<style lang="scss" scoped>
  /* other styles conflicting */
  label::before {
    content: none !important;
  }

  .checkbox-container {
    position: relative;
  }

  input[type=checkbox] {
    display: none;
  }

  label {
    padding-left: 2rem;
    cursor: pointer;
  }

  label span {
    display: block;
    position: absolute;
    left: 0;
    top: 2px;
    transition-duration: 0.3s;
  }

  label .checkbox-box {
    border: 1px solid #ccc;
    border-radius: 3px;
    height: 16px;
    width: 16px;
    transition-delay: 100ms;
  }

  label .checkbox-check {
    top: 1px;
    left: 6px;
    width: 8px;
    height: 16px;
    border: 2px solid #28a745;
    border-top: 0;
    border-left: 0;
    opacity: 0;
    transform: rotate(180deg);
    transition-delay: 100ms;
  }

  input[type=checkbox]:checked ~ label .checkbox-box {
    opacity: 0;
    transform: scale(0) rotate(-180deg);
  }

  input[type=checkbox]:checked ~ label .checkbox-check {
    opacity: 1;
    transform: scale(1) rotate(45deg);
  }

  .checkbox-label {
    font-size: 13px;
  }
</style>
